export default "__VITE_ASSET__BdRTT4Fz__"